import moment from "@/date";
import { RoleInterface, RoleSmallInterface } from "@/modules/roles/types";
import { ReportInterface } from "../types";

type RoleWithReportingFlags = Partial<Pick<RoleInterface, "reportable">>;
type RoleWithDates = RoleWithReportingFlags &
  Pick<RoleInterface, "start_date"> & {
    end_date?: string | null;
  };

export const isRoleReportable = (role?: RoleWithReportingFlags | RoleSmallInterface): boolean => {
  return role?.reportable !== false;
};

export const getReportableRolesForDate = <T extends RoleWithDates>(
  roles: Array<T>,
  date: string | Date
): Array<T> => {
  const selectedDate = moment(date);
  return roles.filter((role) => {
    return (
      isRoleReportable(role) &&
      selectedDate.isSameOrAfter(role.start_date, "day") &&
      (!role.end_date || selectedDate.isSameOrBefore(role.end_date, "day"))
    );
  });
};

export const canCopyReportRole = (report?: Pick<ReportInterface, "role">): boolean => {
  return isRoleReportable(report?.role);
};
